<form nz-form class="h-100" [formGroup]="form">
  <p class="mb-4">قم بإضافة كافة وحدات القياس اللازمة لجدول الكميات ..</p>

  <nz-form-item class="col-12" nzRequired>
    <div class="d-flex align-items-center w-100 gap-3">
      <nz-form-control style="max-width: 474px" class="flex-fill">
        <input
          #input
          formControlName="name"
          nz-input
          nzSize="large"
          name="name"
          [placeholder]="'وحدة القيــاس'"
          (keydown.enter)="onSubmit()"
          type="text"
          id="name"
        />
      </nz-form-control>
      <button
        nz-tooltip
        nzTooltipTitle="حفـــــظ"
        (click)="onSubmit()"
        [disabled]="submitting"
        class="btn w-60px h-60px ratio-1x1 rounded-4"
        [ngClass]="{ 'btn-success ': successed, 'btn-secondary ': !successed }"
        type="button"
        id=""
      >
        <ng-container *ngIf="!submitting">
          <span *ngIf="!form.value.id && !successed" class="aya-plus"></span>
          <span *ngIf="form.value.id && !successed" class="aya-edit-2"></span>
          <span *ngIf="successed" class="aya-check"></span>
        </ng-container>
        <span
          *ngIf="submitting"
          class="spinner-border text-light spinner-border-sm"
        ></span>
      </button>
      <button
        *ngIf="form.value.id"
        nz-tooltip
        nzTooltipTitle="إلغاء التعــديل"
        (click)="form.reset()"
        [disabled]="submitting"
        class="btn w-60px h-60px btn-light text-gray-700 ratio-1x1 rounded-4"
        type="button"
        id=""
      >
        <span class="aya-close"></span>
      </button>
    </div>
  </nz-form-item>
  <div class="">
    <div
      *ngIf="gettingData"
      class="d-flex justify-content-center align-items-center"
    >
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>
    <div
      *ngIf="!gettingData && (!categories || categories?.length === 0)"
      class="d-flex px-3 justify-content-start align-items-center"
    >
      لا يوجد وحدات قياس بعد
    </div>
    <div class="d-table" style="min-width: 32%">
      <ng-container *ngFor="let item of categories">
        <div class="d-table-row gap-3 hovering-light-table p-2">
          <div
            class="d-table-cell px-2 py-1 rounded-start"
            style="width: max-content"
          >
            <div class="d-flex justify-content-start align-items-center gap-1">
              <span class="text-secondary fw-bold">
                {{ item?.name }}
              </span>
            </div>
          </div>

          <div class="d-table-cell px-2 py-1 text-end rounded-end">
            <div class="d-flex flex-wrap justify-content-end gap-3">
              <button
                (click)="setToEdit(item); input?.focus()"
                type="button"
                class="btn-icon h-40px w-40px fs-14px p-0 btn bg-secondary rounded-circle text-white"
              >
                <span class="aya-edit-2"></span>
              </button>
              <button
                (click)="showDeleteConfirmation(item?.id)"
                type="button"
                class="btn-icon shadow-sm h-40px w-40px fs-14px p-0 btn bg-white shadow-sm text-danger rounded-circle text-info"
              >
                <span class="aya-trash"></span>
              </button>
            </div>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</form>
